import script from "./SszBenchmarkDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SszBenchmarkDetail.vue?vue&type=script&setup=true&lang=js"

import "./SszBenchmarkDetail.vue?vue&type=style&index=0&id=330ae56d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-330ae56d"]])

export default __exports__